const FILE_ICON = {
  PYTHON: 'python',
  EXCEL: 'excel',
  CSV: 'csv',
  TXT: 'txt'
};

export { FILE_ICON };
